import template from './remember.html';
import './remember.scss';

export class RememberController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;

    this.email = '';
    this.errorMessage = '';
  }
  remember() {
    if (!this.loading) {
      const { form } = this;
      if (form.$valid) {
        this.errorMessage = '';
        this.onRemember({ email: this.email });
      } else if (form.$error.email) {
        this.errorMessage = 'Please enter a valid e-mail address';
      } else {
        this.errorMessage = 'Please complete the form';
      }
    }
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      this.errorMessage = error.currentValue;
    }
  }
  get form() {
    return this.$scope.nzLoginBox_form;
  }
}

export default {
  controller: RememberController,
  template,
  bindings: {
    error: '<',
    loading: '<',
    success: '<',
    onRemember: '&',
    goBackUrl: '<',
    privacyPolicyUrl: '<',
  },
};
